import {useState} from 'react'
import {ApiUrbit} from '../../../../../infra/http/urbit'

export const useZonaUso = () => {
  const [zonaUso, setZonaUso] = useState(null)

  async function fetchZonaUso() {

      return await ApiUrbit.get(`zoneamentos/5351`).then((data) => {
        setZonaUso(data)
      })

  }

  return {
    fetchZonaUso,
    zonaUso,
    setZonaUso
  }
}
